"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Brand = void 0;
var Brand;
(function (Brand) {
    Brand["JochenSchweizer"] = "JochenSchweizer";
    Brand["Mydays"] = "mydays";
})(Brand || (exports.Brand = Brand = {}));
//# sourceMappingURL=Brand.js.map